"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeDetailedMarketPrices = subscribeDetailedMarketPrices;
function subscribeDetailedMarketPrices(params) {
    const correlationData = this.addToCorrelation(params);
    const request = { 0: correlationData.correlationDataId };
    if (params.eventClassifierId !== undefined) {
        request[1] = params.eventClassifierId;
        if (params.marketTypesToExclude !== undefined) {
            const marketTypesToExclude = params.marketTypesToExclude;
            request[2] = marketTypesToExclude.join('~');
        }
        if (params.marketTypesToInclude != null) {
            const marketTypesToInclude = params.marketTypesToInclude;
            request[3] = marketTypesToInclude.join('~');
        }
        request[4] = params.wantDirectDescendentsOnly;
    }
    else {
        if (params.marketIds !== undefined) {
            const marketIds = params.marketIds;
            request[5] = marketIds.join('~');
        }
    }
    request[6] = params.numberBackPrices;
    request[7] = params.numberLayPrices;
    request[8] = params.filterByVolume;
    request[11] = params.fetchOnly;
    const correlationDataParams = this._correlationData[correlationData.correlationDataId];
    this._priceChangedDelegates[correlationData.correlationDataId] =
        correlationDataParams;
    //super.addToPushMessages(request);
    this._sendStreamingMessage(10, request);
    return correlationData.promise;
}
